import axios from "axios";
import * as actionType from "../../constant/actionType";
export const InviteWorker = (ApiData,ipAddress) => async (dispatch) => {
      try {
        const response = await axios({
          method: 'post',
          data: ApiData,
          headers: {
            Authorization: `Bearer ${localStorage.getItem('conserve_authtoken')}`,
            userip: ipAddress,
          },
          url: `${actionType.environment_url}/api/admin/worker/InviteWorker`,
        });
        return response.data
      } catch (error) {
        return  error.message
      }
    }